export function webAppParseStartAppParams(
  startAppParam: string | undefined,
): Record<string, string> | null {
  if (!startAppParam) {
    return null;
  }

  try {
    const result: Record<string, string> = {};
    const pairs = startAppParam.split("-");

    for (const pair of pairs) {
      const [key, value] = pair.split("_");

      if (key && value) {
        result[key] = value;
      }
    }

    return result;
  } catch (error) {
    console.error("Failed to parse startapp parameter:", error);

    return null;
  }
}
